import type { RouteRecordRaw } from "vue-router";
import { mimboxExists, hasNoActiveInstallation } from "../guards";

export const mimboxRoutes: RouteRecordRaw[] = [
  {
    path: "/mimbox/public/:id",
    name: "public2",
    // @ts-ignore TODO: convert view to typescript
    component: () => import("../../views/PublicView.vue"),
  },
  {
    path: "/mimbox/public/:id/:qrId",
    name: "public-qr",
    // @ts-ignore TODO: convert view to typescript
    component: () => import("../../views/PublicView.vue"),
    beforeEnter: () => {
      document.body.classList.add("mobile");
    },
    meta: {
      noMargin: true,
    },
  },

  {
    path: "/mimbox",
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        name: "mimboxes",
        component: () => import("../../views/MimboxTableView.vue"),
      },
      {
        path: "new",
        name: "mimbox-new",
        component: () => import("../../views/EditMimboxView.vue"),
        meta: { requiresStaff: true },
      },
      {
        path: ":id",
        beforeEnter: [mimboxExists],
        children: [
          {
            path: "",
            name: "mimbox",
            component: () => import("../../views/mimbox-detail/Detail.vue"),
            meta: {
              requiresFeatures: {
                allowAdminPrivileges: true,
              },
            },
          },
          {
            path: "edit",
            name: "mimbox-edit",
            component: () => import("../../views/EditMimboxView.vue"),
            meta: {
              requiresFeatures: {
                allowAdminPrivileges: true,
              },
            },
          },
          {
            path: "troubleshoot/:code",
            name: "mimbox-troubleshoot-error",
            component: () =>
              import("../../views/QRCode/ServicePortal/troubleshootingGuides/TroubleshootError.vue"),
            meta: {
              noMargin: true,
              requiresFeatures: {
                allowAdminPrivileges: true,
              },
            },
          },
        ],
      },
    ],
  },
  {
    path: "/mimbox/:id/public",
    name: "public",
    // @ts-ignore TODO: convert view to typescript
    component: () => import("../../views/PublicView.vue"),
    meta: {
      noMargin: true,
    },
  },
  {
    path: "/mimbox/:id/setup",
    name: "mimbox-setup",
    // @ts-ignore TODO: convert view to typescript
    component: () => import("../../views/MimboxSetupView.vue"),
    meta: { requiresAuth: true },
    beforeEnter: [hasNoActiveInstallation],
  },
];
